<div class="sm-flex sm-flex-col sm-gap-y-4">
  <div class="sm-flex sm-flex-row sm-gap-x-2">
    <label i18n for="jointVenture" class="sm-w-1/3">Joint venture workspace</label>
    <div class="sm-w-2/3">
      <label class="toggle-control" data-test="joint-venture-toggle" [class.disabled]="!isSuperAdmin" i18n>
        <input
          name="jointVenture"
          type="checkbox"
          [(ngModel)]="model.jointVenture"
          (click)="onJointVentureToggleClicked($event)"
          (change)="onJointVentureChange()"
        />
        <span class="control"></span>
      </label>
    </div>
  </div>

  <div [hidden]="model.jointVenture" class="sm-flex sm-flex-row sm-gap-x-2">
    <label i18n for="domain" class="sm-w-1/3">Domains</label>
    <div class="sm-flex sm-w-2/3 sm-flex-col sm-gap-y-2">
      <input
        type="text"
        name="domain"
        id="domain"
        autocomplete="off"
        class="input-text-base form-domain sm-w-full"
        [class.has-input-error]="domainModel.domainInputError"
        [readonly]="!isSuperAdmin"
        [(ngModel)]="domainModel.domainInput"
        #domainInputRef
      />
      <span *ngIf="domainModel.domainInputError" class="sm-text-xs sm-text-default-red" i18n>
        {{ domainModel.domainInputError }}
      </span>
      <span
        *ngIf="!domainModel.isMissingDomain"
        class="sm-block sm-text-xs sm-text-secondary-text"
        data-test="multiple-domains-message"
        i18n
      >
        Domains must be comma separated.
      </span>
      <div class="sm-max-w-max">
        <div
          *ngIf="domainModel.isMissingDomain"
          class="missing-domain-banner"
          data-test="missing-domain-warning"
          i18n
        >
          <em class="cc-icon cc-icon-warning sm-text-default-dark-orange"></em>
          <span>If a domain has not been defined, Visitor users cannot be added.</span>
        </div>
      </div>
    </div>
  </div>

  <div [hidden]="!model.jointVenture" class="sm-flex sm-flex-col sm-gap-4">
    <div class="sm-flex sm-flex-row sm-gap-x-2">
      <label i18n for="jointVentureDomains" class="sm-w-1/3">Joint-venture domains</label>
      <div class="sm-w-2/3">
        <input
          type="text"
          name="jointVentureDomains"
          id="jointVentureDomains"
          autocomplete="off"
          class="input-text-base form-domain sm-w-full"
          [readonly]="!isSuperAdmin"
          [(ngModel)]="domainModel.jointVentureDomainInput"
          #domainInputRef
        />
        <span *ngIf="domainModel.jointVentureDomainInputError" class="sm-text-xs sm-text-default-red" i18n>
          {{ domainModel.jointVentureDomainInputError }}
        </span>
      </div>
    </div>
    <div class="sm-flex sm-flex-row sm-gap-x-2">
      <label i18n for="parentDomains" class="sm-w-1/3">Parent domains</label>
      <div class="sm-flex sm-w-2/3 sm-flex-col">
        <input
          type="text"
          name="parentDomains"
          id="parentDomains"
          autocomplete="off"
          class="input-text-base form-domain sm-w-full"
          [readonly]="!isSuperAdmin"
          [(ngModel)]="domainModel.parentDomainInput"
          #domainInputRef
        />
        <span *ngIf="domainModel.parentDomainInputError" class="sm-text-xs sm-text-default-red" i18n>
          {{ domainModel.parentDomainInputError }}
        </span>
        <span class="sm-block sm-text-xs sm-text-secondary-text" i18n>
          Domains must be comma separated.
        </span>
      </div>
    </div>
  </div>
</div>
